import React, { useContext } from 'react';

import { Body } from '../../styles/homeStyles';
import { Flex, TextBox } from '../../styles/globalStyles';
import { Button } from '../../styles/commonStyles';
import Layout from '../../components/Layout';

import { LayoutContext } from '../../context/layoutContext';

const NotFound = ({ history }) => {
  const { matchese } = useContext(LayoutContext);

  return (
    <Layout>
      <Body>
        <TextBox>
          <Flex
            flexDirection='column'
            justifyContent='center'
            style={{ width: '100%', height: '70vh', fontSize: matchese ? '17px' : '21px' }}
          >
            <b className='blue' style={{ fontSize: '40px', fontWeight: 100 }}>
              404
            </b>
            <b className='blue'>죄송합니다. 현재 찾을 수 없는 페이지를 요청 하였습니다.</b>

            <Flex flexDirection='column' justifyContent='center' style={{ width: '100%', fontSize: matchese ? '15px' : '17px' }}>
              <p className='sub' style={{ textAlign: 'center', margin: '15px 0', lineHeight: '1.3' }}>
                존재하지 않는 주소를 입력 하였거나, <br /> 요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.
              </p>
              <p className='sub' style={{ textAlign: 'center', margin: '5px 0' }}>
                궁금한 점이 있으시면 언제든 고객센터를 통해 문의해 주시기 바랍니다.
              </p>
              <p className='sub' style={{ textAlign: 'center', margin: '10px 0 15px' }}>
                감사합니다.
              </p>
            </Flex>

            <Flex width='100%' flexWrap='wrap'>
              <Button
                style={{ width: matchese ? '100%' : '105px', height: matchese ? '40px' : '35px', margin: '5px' }}
                onClick={() => history.push(process.env.PUBLIC_URL + '/home')}
              >
                메인으로
              </Button>
              <Button
                Cancel={true}
                style={{ width: matchese ? '100%' : '105px', height: matchese ? '40px' : '35px', margin: '5px' }}
                onClick={() => history.goBack()}
              >
                이전페이지
              </Button>
            </Flex>
          </Flex>
        </TextBox>
      </Body>
    </Layout>
  );
};

export default NotFound;
